// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"05d1dc4b","977":"193f0965"}[chunkId] + ".chunk.js";
};